// SOLO mode 用サンプルデッキ定義 (= DDSIM-18)。
// 各デッキは V07-001〜V07-010 の card_id_str で構成された 40 枚の string[]。
// engine の new_match は MIN_DECK_SIZE=40 / MAX_DECK_SIZE=60 を必須とするため、
// 各 cards 配列は正確に 40 要素であること。

export interface SampleDeck {
  id: string;
  name: string;
  cards: string[]; // card_id_str[]、length === 40
}

// ビートダウン: 低コスト (cost ≤2) 速攻。 開始 charge=2 で turn1 召喚が成立する構成。
const beatdown: SampleDeck = {
  id: "sample-beatdown",
  name: "ビートダウン",
  cards: [
    // V07-001 リキッドスライム (cost=1) × 14
    "V07-001", "V07-001", "V07-001", "V07-001", "V07-001",
    "V07-001", "V07-001", "V07-001", "V07-001", "V07-001",
    "V07-001", "V07-001", "V07-001", "V07-001",
    // V07-002 虐げられる貧民 (cost=1) × 13
    "V07-002", "V07-002", "V07-002", "V07-002", "V07-002",
    "V07-002", "V07-002", "V07-002", "V07-002", "V07-002",
    "V07-002", "V07-002", "V07-002",
    // V07-003 ロボットルーパー (cost=2) × 13
    "V07-003", "V07-003", "V07-003", "V07-003", "V07-003",
    "V07-003", "V07-003", "V07-003", "V07-003", "V07-003",
    "V07-003", "V07-003", "V07-003",
  ], // 40枚 (= 14 + 13 + 13)
};

// コントロール: 守備寄り + バランス型 (V07-001〜005, V07-008)
const control: SampleDeck = {
  id: "sample-control",
  name: "コントロール",
  cards: [
    // V07-001 リキッドスライム (cost=1) × 8
    "V07-001", "V07-001", "V07-001", "V07-001",
    "V07-001", "V07-001", "V07-001", "V07-001",
    // V07-002 虐げられる貧民 (cost=1, def=3000) × 8
    "V07-002", "V07-002", "V07-002", "V07-002",
    "V07-002", "V07-002", "V07-002", "V07-002",
    // V07-003 ロボットルーパー (cost=2, def=4000) × 8
    "V07-003", "V07-003", "V07-003", "V07-003",
    "V07-003", "V07-003", "V07-003", "V07-003",
    // V07-005 動く石像 (cost=3, def=4000) × 8
    "V07-005", "V07-005", "V07-005", "V07-005",
    "V07-005", "V07-005", "V07-005", "V07-005",
    // V07-008 トゲトカゲ (cost=4, def=7000) × 8
    "V07-008", "V07-008", "V07-008", "V07-008",
    "V07-008", "V07-008", "V07-008", "V07-008",
  ], // 40枚
};

// 大型: 高コスト高打点モンスター中心 (V07-007〜010)
const bigBeat: SampleDeck = {
  id: "sample-bigbeat",
  name: "大型モンスター",
  cards: [
    // V07-001 リキッドスライム (cost=1) × 10 (序盤つなぎ)
    "V07-001", "V07-001", "V07-001", "V07-001", "V07-001",
    "V07-001", "V07-001", "V07-001", "V07-001", "V07-001",
    // V07-007 ドラゴンランサー (cost=3, atk=6000) × 10
    "V07-007", "V07-007", "V07-007", "V07-007", "V07-007",
    "V07-007", "V07-007", "V07-007", "V07-007", "V07-007",
    // V07-009 闇の王-ダークキング- (cost=6, atk=7000) × 10
    "V07-009", "V07-009", "V07-009", "V07-009", "V07-009",
    "V07-009", "V07-009", "V07-009", "V07-009", "V07-009",
    // V07-010 ダイダラボッチ (cost=8, atk=10000) × 10
    "V07-010", "V07-010", "V07-010", "V07-010", "V07-010",
    "V07-010", "V07-010", "V07-010", "V07-010", "V07-010",
  ], // 40枚
};

export const SAMPLE_DECKS: SampleDeck[] = [beatdown, control, bigBeat];
